import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileSizeService {

  public mobileWidthBS = new BehaviorSubject<boolean>(false);
  constructor() { }
}
